"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'airplay';
exports.SET_AIRPLAY_CONNECTED = exports.namespace + "/SET_AIRPLAY_CONNECTED";
exports.SET_AIRPLAY_AVAILABLE = exports.namespace + "/SET_AIRPLAY_AVAILABLE";
//# sourceMappingURL=constants.js.map